import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hello! I would like to inquire about your automation services.');
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-8 left-8 w-16 h-16 bg-green-500 hover:bg-green-600 flex items-center justify-center shadow-lg hover:shadow-green-500/50 transition-all duration-400 z-50 group animate-pulse hover:animate-none"
      aria-label="Contact us on WhatsApp"
      style={{ borderRadius: '50%' }}
    >
      <MessageCircle className="text-white group-hover:scale-110 transition-transform" size={32} />
    </button>
  );
};

export default WhatsAppButton;
